module.exports = __webpack_public_path__ + "static/media/DroneControlCenter.6d4baa86.png";